import { Box, Button, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";

export default function OrderTableOrderIdCell({
  rowData,
  client,
  inspectorFirm,
}: any) {
  const navigate = useNavigate();
  const onOrderIdClick = () => {
    if (client?.id) {
      navigate(
        `/clients/${client?.id}/orders/Order #(${rowData?.orderNumber})`,
        {
          state: {
            order: rowData,
            breadcrumb: {
              names: {
                [client?.id]: client?.clientName,
              },
            },
          },
        }
      );
    } else if (inspectorFirm?.id) {
      navigate(
        `/inspection-firms/${inspectorFirm?.id}/orders/Order #(${rowData?.orderNumber})`,
        {
          state: {
            order: rowData,
            breadcrumb: {
              names: {
                [inspectorFirm?.id]: inspectorFirm?.displayName,
              },
            },
          },
        }
      );
    } else {
      navigate(`/orders/Order #(${rowData?.orderNumber})`, {
        state: {
          order: rowData,
        },
      });
    }
  };
  return (
    <Box>
      <Button sx={{ textTransform: "none" }} onClick={onOrderIdClick}>
        <Typography>{rowData.orderNumber}</Typography>
      </Button>
    </Box>
  );
}
